import React, { useState, useEffect } from "react";
import { apiClient } from "../../../services/api/apiClient";

function ImportHangerGroupModal({
  isOpen,
  onClose,
  trade,
  submittalId,
  onSuccess,
}) {
  const [materialTypes, setMaterialTypes] = useState([]);
  const [selectedMaterialType, setSelectedMaterialType] = useState("");
  const [loading, setLoading] = useState(false);

  // Fetch material types when modal opens or trade changes
  useEffect(() => {
    if (isOpen && submittalId && trade) {
      fetchMaterialTypes();
    }
  }, [isOpen, submittalId, trade]);

  const fetchMaterialTypes = async () => {
    setLoading(true);
    try {
      const response = await apiClient.post("/hangers/material-types", {
        submittal: submittalId,
        trade: trade,
      });

      // Assuming the API returns the material types in response.data
      setMaterialTypes(response.data || []);
    } catch (error) {
      console.error("Error fetching material types:", error);
      setMaterialTypes([]);
    } finally {
      setLoading(false);
    }
  };

  const handleMaterialTypeChange = (e) => {
    setSelectedMaterialType(e.target.value);
  };

  const handleImport = async () => {
    if (!selectedMaterialType) {
      alert("Please select a material type");
      return;
    }

    setLoading(true);
    try {
      console.log(
        "Importing material type:",
        selectedMaterialType,
        "for trade:",
        trade
      );

      // Call the populate hanger group API
      const response = await apiClient.post("/hangers/populate-group", {
        submittal: submittalId,
        trade: trade,
        material: selectedMaterialType,
      });

      console.log("Import response:", response);
      alert(`Successfully imported hanger group for ${selectedMaterialType}`);

      // Close modal and refresh parent component
      if (onSuccess) {
        onSuccess();
      }
      onClose();
    } catch (error) {
      console.error("Error importing hanger group:", error);
      alert("Error importing hanger group. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    // Close modal only if clicking on the backdrop, not the modal content
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50"
      onClick={handleBackdropClick}
    >
      <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-md max-h-[80vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-gray-900">
            Select Pipe Material for Hanger Specs
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-xl font-bold hover:bg-gray-100 rounded-full w-8 h-8 flex items-center justify-center transition-colors"
          >
            ×
          </button>
        </div>

        {/* Modal content */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Material Type
          </label>
          <select
            value={selectedMaterialType}
            onChange={handleMaterialTypeChange}
            disabled={loading}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <option value="">
              {loading ? "Loading..." : "Select a material type"}
            </option>
            {materialTypes.map((materialType) => (
              <option
                key={materialType.material}
                value={materialType.material}
              >
                {materialType.material}
              </option>
            ))}
          </select>
        </div>

        {/* Import Button */}
        <div className="flex justify-end">
          <button
            type="button"
            onClick={handleImport}
            disabled={!selectedMaterialType || loading}
            className="px-6 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
          >
            {loading ? "Importing..." : "Import Hanger Specs"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ImportHangerGroupModal;
